/* eslint-disable import/first */
require('scss/mixins.scss'); // webpack 4 dynamic import workaround
/**
 * Helpers
 */
import EA from 'helpers/init';

/**
 * Plugins
 */

/**
 * Methods
 */
import 'methods/languageChoose';
import 'methods/saveLangCookie';
import 'methods/bannerAdd';
import 'methods/smoothScroll';
import 'methods/sliderBig';
import 'methods/stickyNav';
import 'methods/headerChange';
import 'methods/mobileMenu';
import 'methods/sliderSix';
import 'methods/dropdown';
import 'methods/galleryModal';
import 'methods/addActive';
import 'methods/videoDetect';
import 'methods/bannerSetup';
import 'methods/bannerSticky';
import 'methods/blockMasonry';
import 'methods/sliderHoliday';
import 'methods/imageLazyLoad';
import 'methods/videoLazyLoad';

/**
 * Vue
 */
import { createApp, defineAsyncComponent } from 'vue';

/**
 * Router
 */
// import { createWebHistory, createRouter } from 'vue-router';

const app = createApp({
    components: {
        CategoryList: defineAsyncComponent(() => import('components/CategoryList.vue')),
        ScrollGallery: defineAsyncComponent(() => import('components/ScrollGallery.vue')),
        LoadGallery: defineAsyncComponent(() => import('components/LoadGallery.vue')),
        MoreNews: defineAsyncComponent(() => import('components/MoreNews.vue')),
        newsletter: defineAsyncComponent(() => import('components/newsletter.vue')),
        Search: defineAsyncComponent(() => import('components/Search.vue')),
        SearchResults: defineAsyncComponent(() => import('components/SearchResults.vue')),
        ChooseLanguage: defineAsyncComponent(() => import('components/ChooseLanguage.vue')),
        HomeNews: defineAsyncComponent(() => import('components/HomeNews.vue')),
        HolidayLoad: defineAsyncComponent(() => import('components/HolidayLoad.vue')),
    },
    mounted() {
        EA.loadMethods();
    }
});
//
// const router = createRouter({
//     history: createWebHistory(),
//     routes: []
// });

// app.use(router);
app.mount('#app');
